import {
  FETCH_GENERAL_TOTAL_START,
  FETCH_GENERAL_TOTAL_SUCCESS,
  FETCH_GENERAL_TOTAL_ERROR,
  FETCH_GENERAL_TOTAL_CUMULATIVE_START,
  FETCH_GENERAL_TOTAL_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_TOTAL_CUMULATIVE_ERROR,
  FETCH_GENERAL_TOTAL_TODAY_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_USD_TOTAL_TODAY_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_EUR_TOTAL_TODAY_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_TOTAL_THIS_MONTH_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_TOTAL_LAST_MONTH_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_TOTAL_DAILY_THIS_MONTH_SUCCESS,
  FETCH_GENERAL_TOTAL_DAILY_LAST_MONTH_SUCCESS,
  FETCH_GENERAL_USD_TOTAL_DAILY_SUCCESS,
  FETCH_GENERAL_EUR_TOTAL_DAILY_SUCCESS,
  FETCH_GENERAL_TOTAL_HOURLY_SUCCESS,
  FETCH_GENERAL_USD_TOTAL_HOURLY_SUCCESS,
  FETCH_GENERAL_EUR_TOTAL_HOURLY_SUCCESS,
  FETCH_GENERAL_TOTAL_MONTH_SUCCESS,
  FETCH_GENERAL_TOTAL_LAST_MONTH_SUCCESS,
  FETCH_GENERAL_TOTAL_THIS_MONTH_SUCCESS,
  FETCH_GENERAL_EUR_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_USD_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_TOTAL_START,
  FETCH_MERCHANT_TOTAL_SUCCESS,
  FETCH_MERCHANT_TOTAL_ERROR,
  FETCH_MERCHANT_TOTAL_CUMULATIVE_START,
  FETCH_MERCHANT_TOTAL_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_TOTAL_CUMULATIVE_ERROR,
  FETCH_MERCHANT_TOTAL_TODAY_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_USD_TOTAL_TODAY_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_EUR_TOTAL_TODAY_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_TOTAL_THIS_MONTH_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_TOTAL_LAST_MONTH_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_TOTAL_DAILY_THIS_MONTH_SUCCESS,
  FETCH_MERCHANT_TOTAL_DAILY_LAST_MONTH_SUCCESS,
  FETCH_MERCHANT_USD_TOTAL_DAILY_SUCCESS,
  FETCH_MERCHANT_EUR_TOTAL_DAILY_SUCCESS,
  FETCH_MERCHANT_TOTAL_HOURLY_SUCCESS,
  FETCH_MERCHANT_USD_TOTAL_HOURLY_SUCCESS,
  FETCH_MERCHANT_EUR_TOTAL_HOURLY_SUCCESS,
  FETCH_MERCHANT_TOTAL_MONTH_SUCCESS,
  FETCH_MERCHANT_TOTAL_LAST_MONTH_SUCCESS,
  FETCH_MERCHANT_TOTAL_THIS_MONTH_SUCCESS,
  FETCH_MERCHANT_EUR_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_USD_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  // general
  generalDaily: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  generalDailyThisMonth: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  generalDailyLastMonth: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  generalMonth: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  generalThisMonth: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  generalLastMonth: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  generalDailyUsd: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  generalDailyEur: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  generalHourly: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  generalHourlyUsd: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  generalHourlyEur: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  generalAllPeriods: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  generalTotal: {
    data: {
      total_amount: 0,
      total_amount_today: 0,
      total_amount_yesterday: 0,
      total_amount_this_month: 0,
      total_amount_last_month: 0,
    },
    loading: false,
    error: null,
  },
  generalUsdTotal: {
    data: {
      total_amount: 0,
      total_amount_today: 0,
      total_amount_yesterday: 0,
      total_amount_this_month: 0,
      total_amount_last_month: 0,
    },
    loading: false,
    error: null,
  },
  generalEurTotal: {
    data: {
      total_amount: 0,
      total_amount_today: 0,
      total_amount_yesterday: 0,
      total_amount_this_month: 0,
      total_amount_last_month: 0,
    },
    loading: false,
    error: null,
  },
  // merchant
  merchantDaily: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  merchantDailyThisMonth: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  merchantDailyLastMonth: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  merchantMonth: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  merchantThisMonth: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  merchantLastMonth: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  merchantDailyUsd: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  merchantDailyEur: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  merchantHourly: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  merchantHourlyUsd: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  merchantHourlyEur: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  merchantAllPeriods: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  merchantTotal: {
    data: {
      total_amount: 0,
      total_amount_today: 0,
      total_amount_yesterday: 0,
      total_amount_this_month: 0,
      total_amount_last_month: 0,
    },
    loading: false,
    error: null,
  },
  merchantUsdTotal: {
    data: {
      total_amount: 0,
      total_amount_today: 0,
      total_amount_yesterday: 0,
      total_amount_this_month: 0,
      total_amount_last_month: 0,
    },
    loading: false,
    error: null,
  },
  merchantEurTotal: {
    data: {
      total_amount: 0,
      total_amount_today: 0,
      total_amount_yesterday: 0,
      total_amount_this_month: 0,
      total_amount_last_month: 0,
    },
    loading: false,
    error: null,
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_GENERAL_TOTAL_START: {
      return {
        ...state,
        generalTotals: {
          loading: true,
        },
      };
    }

    case FETCH_GENERAL_TOTAL_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;

      return {
        ...state,
        generalAllPeriods: {
          ...state.generalAllPeriods,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }

    case FETCH_GENERAL_TOTAL_DAILY_THIS_MONTH_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        generalDailyThisMonth: {
          ...state.generalDailyThisMonth,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_GENERAL_TOTAL_DAILY_LAST_MONTH_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        generalDailyLastMonth: {
          ...state.generalDailyLastMonth,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }

    case FETCH_GENERAL_USD_TOTAL_DAILY_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;

      return {
        ...state,
        generalDailyUsd: {
          ...state.generalDailyUsd,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_GENERAL_EUR_TOTAL_DAILY_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;

      return {
        ...state,
        generalDailyEur: {
          ...state.generalDailyEur,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }

    case FETCH_GENERAL_TOTAL_HOURLY_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        generalHourly: {
          ...state.generalHourly,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_GENERAL_USD_TOTAL_HOURLY_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        generalHourlyUsd: {
          ...state.generalHourlyUsd,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_GENERAL_EUR_TOTAL_HOURLY_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        generalHourlyEur: {
          ...state.generalHourlyEur,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }

    case FETCH_GENERAL_TOTAL_MONTH_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;

      return {
        ...state,
        generalMonth: {
          ...state.generalMonth,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_GENERAL_TOTAL_THIS_MONTH_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;

      return {
        ...state,
        generalThisMonth: {
          ...state.generalThisMonth,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_GENERAL_TOTAL_LAST_MONTH_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;

      return {
        ...state,
        generalLastMonth: {
          ...state.generalLastMonth,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }

    case FETCH_GENERAL_TOTAL_ERROR: {
      return {
        ...state,
        generalTotals: {
          ...state.generalTotals,
          loading: false,
        },
      };
    }

    case FETCH_GENERAL_TOTAL_CUMULATIVE_START: {
      return {
        ...state,
        generalTotal: {
          loading: true,
        },
      };
    }

    case FETCH_GENERAL_TOTAL_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        generalTotal: {
          ...state.generalTotal,
          loading: false,
          data: {
            ...state.generalTotal.data,
            total_amount: data.total_amount,
          }
        },
      };
    }

    case FETCH_GENERAL_TOTAL_TODAY_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        generalTotal: {
          ...state.generalTotal,
          loading: false,
          data: {
            ...state.generalTotal.data,
            total_amount_today: data.total_amount,
          }
        },
      };
    }

    case FETCH_GENERAL_USD_TOTAL_TODAY_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        generalUsdTotal: {
          ...state.generalUsdTotal,
          loading: false,
          data: {
            ...state.generalUsdTotal.data,
            total_amount_today: data.total_amount,
          }
        },
      };
    }
    case FETCH_GENERAL_EUR_TOTAL_TODAY_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        generalEurTotal: {
          ...state.generalEurTotal,
          loading: false,
          data: {
            ...state.generalEurTotal.data,
            total_amount_today: data.total_amount,
          }
        },
      };
    }
    case FETCH_GENERAL_USD_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        generalUsdTotal: {
          ...state.generalUsdTotal,
          loading: false,
          data: {
            ...state.generalUsdTotal.data,
            total_amount_yesterday: data.total_amount,
          }
        },
      };
    }
    case FETCH_GENERAL_EUR_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        generalEurTotal: {
          ...state.generalEurTotal,
          loading: false,
          data: {
            ...state.generalEurTotal.data,
            total_amount_yesterday: data.total_amount,
          }
        },
      };
    }

    case FETCH_GENERAL_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        generalTotal: {
          ...state.generalTotal,
          loading: false,
          data: {
            ...state.generalTotal.data,
            total_amount_yesterday: data.total_amount,
          }
        },
      };
    }

    case FETCH_GENERAL_TOTAL_THIS_MONTH_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        generalTotal: {
          ...state.generalTotal,
          loading: false,
          data: {
            ...state.generalTotal.data,
            total_amount_this_month: data.total_amount,
          }
        },
      };
    }
    case FETCH_GENERAL_TOTAL_LAST_MONTH_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        generalTotal: {
          ...state.generalTotal,
          loading: false,
          data: {
            ...state.generalTotal.data,
            total_amount_last_month: data.total_amount,
          }
        },
      };
    }

    case FETCH_GENERAL_TOTAL_CUMULATIVE_ERROR: {
      return {
        ...state,
        generalTotal: {
          ...state.generalTotal,
          loading: false,
        },
      };
    }

    // Merchant

    case FETCH_MERCHANT_TOTAL_START: {
      return {
        ...state,
        merchantTotals: {
          loading: true,
        },
      };
    }
    case FETCH_MERCHANT_TOTAL_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;

      return {
        ...state,
        merchantAllPeriods: {
          ...state.merchantAllPeriods,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_MERCHANT_TOTAL_DAILY_THIS_MONTH_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        merchantDailyThisMonth: {
          ...state.merchantDailyThisMonth,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_MERCHANT_TOTAL_DAILY_LAST_MONTH_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        merchantDailyLastMonth: {
          ...state.merchantDailyLastMonth,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_MERCHANT_USD_TOTAL_DAILY_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;

      return {
        ...state,
        merchantDailyUsd: {
          ...state.merchantDailyUsd,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_MERCHANT_EUR_TOTAL_DAILY_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;

      return {
        ...state,
        merchantDailyEur: {
          ...state.merchantDailyEur,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_MERCHANT_TOTAL_HOURLY_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        merchantHourly: {
          ...state.merchantHourly,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_MERCHANT_USD_TOTAL_HOURLY_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        merchantHourlyUsd: {
          ...state.merchantHourlyUsd,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_MERCHANT_EUR_TOTAL_HOURLY_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        merchantHourlyEur: {
          ...state.merchantHourlyEur,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_MERCHANT_TOTAL_MONTH_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;

      return {
        ...state,
        merchantMonth: {
          ...state.merchantMonth,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_MERCHANT_TOTAL_THIS_MONTH_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;

      return {
        ...state,
        merchantThisMonth: {
          ...state.merchantThisMonth,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_MERCHANT_TOTAL_LAST_MONTH_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;

      return {
        ...state,
        merchantLastMonth: {
          ...state.merchantLastMonth,
          loading: false,
          data,
          totalItems,
          currentPage
        }
      };
    }
    case FETCH_MERCHANT_TOTAL_ERROR: {
      return {
        ...state,
        merchantTotals: {
          ...state.merchantTotals,
          loading: false,
        },
      };
    }
    case FETCH_MERCHANT_TOTAL_CUMULATIVE_START: {
      return {
        ...state,
        merchantTotal: {
          loading: true,
        },
      };
    }
    case FETCH_MERCHANT_TOTAL_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        merchantTotal: {
          ...state.merchantTotal,
          loading: false,
          data: {
            ...state.merchantTotal.data,
            total_amount: data.total_amount,
          }
        },
      };
    }
    case FETCH_MERCHANT_TOTAL_TODAY_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        merchantTotal: {
          ...state.merchantTotal,
          loading: false,
          data: {
            ...state.merchantTotal.data,
            total_amount_today: data.total_amount,
          }
        },
      };
    }
    case FETCH_MERCHANT_USD_TOTAL_TODAY_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        merchantUsdTotal: {
          ...state.merchantUsdTotal,
          loading: false,
          data: {
            ...state.merchantUsdTotal.data,
            total_amount_today: data.total_amount,
          }
        },
      };
    }
    case FETCH_MERCHANT_EUR_TOTAL_TODAY_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        merchantEurTotal: {
          ...state.merchantEurTotal,
          loading: false,
          data: {
            ...state.merchantEurTotal.data,
            total_amount_today: data.total_amount,
          }
        },
      };
    }
    case FETCH_MERCHANT_USD_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        merchantUsdTotal: {
          ...state.merchantUsdTotal,
          loading: false,
          data: {
            ...state.merchantUsdTotal.data,
            total_amount_yesterday: data.total_amount,
          }
        },
      };
    }
    case FETCH_MERCHANT_EUR_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        merchantEurTotal: {
          ...state.merchantEurTotal,
          loading: false,
          data: {
            ...state.merchantEurTotal.data,
            total_amount_yesterday: data.total_amount,
          }
        },
      };
    }
    case FETCH_MERCHANT_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        merchantTotal: {
          ...state.merchantTotal,
          loading: false,
          data: {
            ...state.merchantTotal.data,
            total_amount_yesterday: data.total_amount,
          }
        },
      };
    }
    case FETCH_MERCHANT_TOTAL_THIS_MONTH_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        merchantTotal: {
          ...state.merchantTotal,
          loading: false,
          data: {
            ...state.merchantTotal.data,
            total_amount_this_month: data.total_amount,
          }
        },
      };
    }
    case FETCH_MERCHANT_TOTAL_LAST_MONTH_CUMULATIVE_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        merchantTotal: {
          ...state.merchantTotal,
          loading: false,
          data: {
            ...state.merchantTotal.data,
            total_amount_last_month: data.total_amount,
          }
        },
      };
    }
    case FETCH_MERCHANT_TOTAL_CUMULATIVE_ERROR: {
      return {
        ...state,
        merchantTotal: {
          ...state.merchantTotal,
          loading: false,
        },
      };
    }

    default:
      return state;
  }
};
